import { v4 as uuid } from "uuid";

export const products = [

  {
    _id: uuid(),
    title: "JORDAN Women's Air 1 Mid SE CZ4385 016 - Shiekh",
    image: "https://static.shiekh.com/media/catalog/product/cache/image/2000x2000/e9c3970ab036de70892d86c6d221abfe/3/e/3e9449ef67e937fcbf6148a4106ef188.jpg",
    price: 11295,
    rating: 2,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Air Jordan 1 Low SE W White, Royal & Red | END. (KR)",
    image: "https://media.endclothing.com/media/f_auto,q_auto:eco/prodmedia/media/catalog/product/1/1/11-08-2020_CZ4776-101_2_1.jpg",
    price: 18950.00,
    rating: 4,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "JORDAN 4 RETRO SE (PS) (BQ9042-005, size: 13C)",
    image: "https://i5.walmartimages.com/asr/89dbe0e5-f4d1-48c0-a7af-b3e467337025.b22e4ebb191390070fda8aac5ed795ba.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price: 11895,
    rating: 3,
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "Jordan Womens Air 1 Low Basketball Shoes,Black/Gym Red-sail,5",
    image: "https://i5.walmartimages.com/asr/125dc5aa-13a7-40cc-82f9-d5ee06d0b6b7.9b7927d38719a52f16a8ea687631c61e.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    rating: 4,
    price: 18950.0,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Big Kids Jordan 1 Mid SE Barcelona Red Patent Chile Rd/Wht-Pollen (DC7248 600) - 4.5",
    image: "	https://i5.walmartimages.com/asr/8a86b4eb-c783-4a06-af87-e1d8f4fb5568.fd4df67eae0e44ba1ea81f8b749d7695.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 8295.00,
    rating: 3,
    categoryName: "Kids",
  },
  {
    _id: uuid(),
    title: "JORDAN WHY NOT ZER0.1",
    image: "https://i5.walmartimages.com/asr/49f962a2-4b9a-4c18-a8f6-806b8c123ed9.da63c8ab19808f853e59aee5af3c43d9.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price: 8995.00,
    categoryName: "Kids",
    rating: 4,
  },
  
  {
    _id: uuid(),
    title: "Women's Jordan Series .05 White/Black/Green Strike-Prime Pink (DM3383 105) - 8",
    image: "https://i5.walmartimages.com/asr/a9e15b7f-b407-49b8-ac74-a53920e002ae.d9cd112f2c618db09dd662399f87d9df.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF	",
    price: 18905.0,
    categoryName: "Women",
    rating: 2,
  },
  {
    _id: uuid(),
    title: "Nike Jordan Access Men's Basketball Shoes AR3762 008 Size 13 US New in the box",
    image: "https://i5.walmartimages.com/asr/35161461-a056-450b-9cfd-8d3dcc6cd5ea.75c47fd3bcf797630ac954dddf34c816.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 18295.00,
    categoryName: "Men",
    rating: 1,
  },
  {
    _id: uuid(),
    title: "Nike air jordan 1 low homme",
    image: "https://cashcow-cdn.azureedge.net/images/f4b7933e-7fd5-417e-886d-3a32955c74df.png",
    price: 8295.00,
    categoryName: "Women",
    rating: 3,
    
  },
  {
    _id: uuid(),
    title: "Air Jordan 1 Mid Se : 2020 Air Jordan 1 Mid SE Premium 'Stain Gold ...",
    image: "https://limitedresell.com/2775-full_default/air-jordan-1-mid-se-purple.jpg",
    price: 13295,
    categoryName: "Men",
    rating: 4,
  },
  {
    _id: uuid(),
    title: "Jordan 1 Mid Corduroy Women White Sail Orange DA8009-108 10.5",
    image: "https://i5.walmartimages.com/asr/5ab90a85-ffe9-438f-8b7c-b51530429f99.c66181518c8b8ef7f732160be0278dac.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 11895.00,
    rating: 4,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Jordan Jordan Ma2 Womens Shoes Size 12, Color: White/University Red/Black",
    image: "	https://i5.walmartimages.com/asr/54e042ee-546d-4ae8-9479-8a128907d7f1.3d27f6d822891491ed0ece095be09d0b.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price: 19695.0,
    rating: 5,
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "Air Jordan 3 Retro OG DN3707-160 Men's White/Fire Red/Black Sneaker Shoes NX544 (10)",
    image: "	https://i5.walmartimages.com/asr/5685c622-d979-41b0-98c1-6460d8f99488.773fcd76c80fd24c4e6b4649bc55b39a.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 16295.00,
    rating: 4,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Jordan 1 Mid Se Mens Style : Dd6834-802",
    image: "https://i5.walmartimages.com/asr/7546f9a8-2eb8-45dd-9d5c-3898b78dec9a.cf4937100db771483cabb9dc82bf4e39.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 12795.00,
    rating: 5,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Air Jordan I Mid Little Kids' Shoes Tropical Twist-White 640734-132",
    image: "	https://i5.walmartimages.com/asr/e7653674-4872-447e-9b72-e76ecb62426a.7002e829f9792105768d3dc420e3a407.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 10995.00,
    rating: 4,
    categoryName: "Kids",
  },
  {
    _id: uuid(),
    title: "Men's Jordan 11 Retro Cherry White/Varsity Red-Black (CT8012 116) - 9.5",
    image: "	https://i5.walmartimages.com/asr/983124b9-226e-41ca-af95-2d7146b8c8a8.abc1ede8dda31ec3af0090b2f088c5fe.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price: 7877.00,
    rating: 2,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Nike Air Jordan Flight Club '91 Mens Basketball Shoes",
    image: "	https://i5.walmartimages.com/asr/8fd6947b-ce46-405f-ada9-4b9a6efd6a25_1.bfa0f3760be6e8dc60ccfbd1753c71a8.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 14195.00,
    rating: 3,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Nike Mens Air Jordan 1 Mid Shoes",
    image: "https://i5.walmartimages.com/asr/f843d956-5cab-4531-a82b-2914ab8d0ef9.0e341390cb26e1d26413f6a0f60b79fd.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF	",
    price: 8295.00,
    rating: 4,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Women Air Jordan 5 Retro Oreo - Women Jordan Shoes ...",
    image: "https://usgstore.com.au/cdn/shop/files/5988_41a3cb09-d6f6-4fbf-831f-d2ff412db383_1024x1024.png?v=1686897861",
    price: 5766.23,
    rating: 1,
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "JORDAN 10 RETRO SE (PS) (BV1844-176, size: 3Y)",
    image: "https://i5.walmartimages.com/asr/d49f7816-b25c-4b1d-8fa4-800c9c096dcb.dcf06b0297d22c4f76e0c1e15a297c57.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price:  10599.00,
    rating: 4,
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "Nike Men's/Women's Jordan Luka 1 Basketball Shoes",
    image: "https://i5.walmartimages.com/seo/Nike-Men-s-Women-s-Jordan-Luka-1-Basketball-Shoes_119446a7-275d-47ad-9c40-afd92ebe6374.dc8202ea347c70e51a4cadebab5eec63.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price: 11599.00,
    rating: 3,
    categoryName: "Women",
  },
  
  {
    _id: uuid(),
    title: "Women's Jordan 1 Mid SE USA 2022 Gym Red/Midnight Navy-Sail (DQ7648 600) -",
    image: "https://i5.walmartimages.com/asr/19b379bf-741e-4598-8dd7-260feab8bbfd.977a769f76a4a6653b3afc7688a09d6b.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 15766.00,
    rating: 5,
    categoryName: "Women",
  },
  
  {
    _id: uuid(),
    title: "Men's Jordan 1 Retro High OG Visionaire Volt/Black-Sail (555088 702) - 9",
    image: "https://i5.walmartimages.com/seo/Men-s-Jordan-1-Retro-High-OG-Visionaire-Volt-Black-Sail-555088-702-9_ae0f9b00-01e8-4c1d-9190-ace06c364b45.dc971490ecd4e1c47eff0fa6da3b24b4.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 12766.00,
    rating: 3,
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "Men's Jordan 1 Retro High OG Gorge Green/Metallic Silver (DZ5485 303) - 12",
    image: "https://i5.walmartimages.com/asr/52f7abe6-484a-4e0e-84a8-568e31e82769.cad4df7610b5862e228d6b5cb8654218.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 9766.00,
    rating: 4,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Men's Jordan 6 Retro UNC University Blue/White-Black (CT8529 410) - 13",
    image: "	https://i5.walmartimages.com/asr/d2dda6dd-deb9-406a-aef7-fb7eb29f0718.da81c4e1c17245205de79789508d2685.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 18699.00,
    rating: 3,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Men's Jordan 6 Rings White/White-Tropical Twist (322992 115) - 11.5",
    image: "	https://i5.walmartimages.com/asr/bd659834-0ec4-4664-99d4-75f6c1a2c800.d35956c77bd4ad866f84b7bb424d3291.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price:  17399.00,
    rating: 3,
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Little Kid Jordan 1 Mid SE Wear-Away Chicago Blk/Ifr 23-Wht-Sail (FB0567 006) - 3",
    image: "https://i5.walmartimages.com/seo/Little-Kid-Jordan-1-Mid-SE-Wear-Away-Chicago-Blk-Ifr-23-Wht-Sail-FB0567-006-3_3aed12bb-d803-430a-b1e0-1fefb62cb698.9a559ec97f6a5c010bb4f837b488c30f.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price:  6599.00,
    rating: 4,
    categoryName: "Kids",
  },
  {
    _id: uuid(),
    title: "Toddler's Jordan 1 Mid Zen Master Black/Bleached Coral-White (DM6217 001) - 5",
    image: "https://i5.walmartimages.com/seo/Toddler-s-Jordan-1-Mid-Zen-Master-Black-Bleached-Coral-White-DM6217-001-5_36b627a7-cb1a-4e70-8528-fcd476fd1eb8.7545a45fdfc1f8e68e7eac6bc308483f.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 9599.00,
    rating: 3,
    categoryName: "Kids"
  },
  {
    _id: uuid(),
    title: "Little Kid's Jordan 6 Retro Low White/Atmosphere-Infrared 23 (DV3528 102) - 12.5",
    image: "https://i5.walmartimages.com/seo/Little-Kid-s-Jordan-6-Retro-Low-White-Atmosphere-Infrared-23-DV3528-102-12-5_cf13bcc6-a9e4-45f1-b71d-0d9dd8a2d2a0.3f91581ef91c9114a7287fc39922590d.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    price: 10299.00,
    rating: 3,
    categoryName: "Kids"
  },
  {
    _id: uuid(),
    title: "Big Kid's Jordan Max Aura 3 White/Atmosphere-Infrared 23 (DA8021 102) - 6",
    image: "	https://i5.walmartimages.com/asr/964c5884-7fca-4901-bff5-4b3abae39769.63b7e8226a065fca5ca3c73d4c0fd7f9.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price: 13399.00,
    rating: 5,
    categoryName: "Kids"
  },
  {
    _id: uuid(),
    title: "Air Jordan Access AR3762-101 Men's White/Gym Red/Black Running Shoes TV571 (9.5)",
    image: "	https://i5.walmartimages.com/seo/Men-s-Jordan-11-CMFT-Low-White-Black-DV2207-100-9-5_820da7aa-f9a3-4ea2-90cf-993a40d93f30.d8d1bfcc82754b5fae4635045fd6ba50.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price: 16566.00,
    rating: 5,
    categoryName: "Men"
  },
  {
    _id: uuid(),
    title: "Jordan Mens Dub Zero Basketball Shoes",
    image: "https://i5.walmartimages.com/asr/b02b0013-d0f7-412b-b619-ac7d676f050f.25c7aef12e93c7da6556d55a7cb477eb.jpeg?odnHeight=612&odnWidth=612&odnBg=FFFFFF",
    price: 18566.00,
    rating: 5,
    categoryName: "Men"
  },

  
  
];